import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import type { CreatePaymentBody, Payment, UpdatePaymentBody } from '@klopotun/contracts';
import { createPayment } from '../requests/create-payment.js';
import { updatePayment } from '../requests/update-payment.js';
import { invalidatePayment } from './payment-cache.js';

export type SavePaymentInput =
  | { mode: 'create'; body: CreatePaymentBody }
  | { mode: 'update'; id: string; body: UpdatePaymentBody };

const savePayment = (input: SavePaymentInput): Promise<Payment> => {
  if (input.mode === 'create') {
    return createPayment(input.body);
  }
  return updatePayment(input.id, input.body);
};

export const useSavePaymentMutation = (): UseMutationResult<Payment, Error, SavePaymentInput> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: savePayment,
    onSuccess: (payment) => invalidatePayment(queryClient, payment.id),
  });
};
